import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import NextStepsSchema from './schema';
import NextStepsBody from './NextStepsBody';
import type { NextStepsData } from './NextStepsBody';

type NextStepsEditProps = {
  data: NextStepsData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: NextStepsData) => void;
};

const NextStepsEdit = (props: NextStepsEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = NextStepsSchema({ intl });

  return (
    <>
      <NextStepsBody data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default NextStepsEdit;
